const productStockCache = new Map();

function extractNumericId(gidOrId) {
  if (gidOrId == null) return null;
  const match = String(gidOrId).match(/\/(\d+)\s*$/);
  if (match) return Number(match[1]);
  const numericId = Number(gidOrId);
  return Number.isFinite(numericId) ? numericId : null;
}

function getOnlineStockEndpoint() {
  return window.theme?.settings?.storeLocator?.onlineStockUrl?.trim() || '';
}

function getShopParam() {
  const shopDomain = window.theme?.settings?.storeLocator?.shopDomain || window.Shopify?.shop || '';
  return String(shopDomain)
    .replace(/\.myshopify\.com$/i, '')
    .toLowerCase();
}

function normalizeVariantTotals(payload) {
  const totalsByVariantId = new Map();

  (payload?.variants ?? []).forEach((variantEntry) => {
    const variantId = extractNumericId(variantEntry.variantId);
    if (variantId == null) return;

    totalsByVariantId.set(variantId, Number(variantEntry.totalAvailable) || 0);
  });

  return totalsByVariantId;
}

export function clearOnlineFulfillmentStockCache(productId = null) {
  if (productId == null) {
    productStockCache.clear();
    return;
  }

  productStockCache.delete(Number(productId) || productId);
}

export async function fetchOnlineFulfillmentStock(productId) {
  const endpoint = getOnlineStockEndpoint();
  const numericProductId = Number(productId) || productId;

  if (!endpoint || !numericProductId) {
    return null;
  }

  if (productStockCache.has(numericProductId)) {
    return productStockCache.get(numericProductId);
  }

  const shop = getShopParam();
  if (!shop) return null;

  const requestUrl = new URL(endpoint);
  requestUrl.searchParams.set('shop', shop);
  requestUrl.searchParams.set('productId', String(numericProductId));

  const response = await fetch(requestUrl.toString(), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Online fulfillment stock HTTP ${response.status}`);
  }

  const payload = await response.json();
  const totalsByVariantId = normalizeVariantTotals(payload);

  productStockCache.set(numericProductId, totalsByVariantId);
  return totalsByVariantId;
}

export function getOnlineQuantityForVariant(totalsByVariantId, variantId) {
  if (!totalsByVariantId) return null;

  const numericVariantId = Number(variantId);
  if (totalsByVariantId.has(numericVariantId)) {
    return totalsByVariantId.get(numericVariantId);
  }

  return null;
}
